export const TOGGLE_STATUSBOARD = 'TOGGLE_STATUSBOARD';
export const TOGGLE_CHANGESTATUSBOARD = 'TOGGLE_CHANGESTATUSBOARD';
export const TOGGLE_SHIFTPERFORMANCEBOARD = 'TOGGLE_SHIFTPERFORMANCEBOARD';
export const TOGGLE_OEEBOARD = 'TOGGLE_OEEBOARD';
export const TOGGLE_PROGRESSIONBOARD = 'TOGGLE_PROGRESSIONBOARD';
export const TOGGLE_MESSAGESBOARD = 'TOGGLE_MESSAGESBOARD';
export const TOGGLE_SPEEDBOARD = 'TOGGLE_SPEEDBOARD';
export const TOGGLE_CURRENTORDERBOARD = 'TOGGLE_CURRENTORDERBOARD';
export const TOGGLE_NEXTORDERBOARD = 'TOGGLE_NEXTORDERBOARD';
export const SET_DASHBOARDCONFIGURATIONDRAWEROPEN = 'SET_DASHBOARDCONFIGURATIONDRAWEROPEN';
export const SET_PROGRESSIONS = 'SET_PROGRESSIONS';





